export const previewConst = {
  accessContent: 'Access this content',
  endorsed: 'Endorsed',
  // eyKnowledgeText: 'Powered by Global Markets',
   eyKnowledgeText: 'Powered by Clients & Industries',
  lastUpdated: 'Last Updated: ',
  endorsedByAltText: 'Endorsed By',
  closePreviewLabel: 'Close Preview',
  downloadLabel: ': Download',
  shareLabel: ': Share',
  documentPreviewLabel: 'Document Preview',
  previewErrorScreenConstants: {
    unavailbleText: 'Document preview is unavailable',
    instructionText: 'Please download this file to see the content',
    previewErrorIconAltText: 'Preview Error Icon'
  },
  lastReviewed: 'Last Reviewed: '
};
